import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getSupportAiPricing = {
  name: "getSupportAiPricing" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ monthlyOrders: z.number(), platformPrice: z.number() }),
};
